export class DialogModel {
  dialogTitle?: string
  dialogContent?: string
  showDeclineButton? = true
  labelOk? = 'Ok'
  labelNo? = 'No'
}
